import React from 'react';

import WalletApolloProvider from '../providers/WalletApolloProvider';

import BigWinningsSubscription from './BigWinningsSubscription';

const GQLClientSubscriptions: React.FC = () => (
  <WalletApolloProvider>
    <BigWinningsSubscription />
  </WalletApolloProvider>
);

export default GQLClientSubscriptions;
